import React from "react";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import { ReactComponent as SupportImg } from "assets/images/support/support-img.svg";
import { ReactComponent as TelegramIcon } from "assets/images/support/telegram-icon.svg";
import { ReactComponent as ViberIcon } from "assets/images/support/viber-icon.svg";
import { ReactComponent as SupportIcon } from "assets/images/support/support-icon.svg";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

import { styles } from "./styles";

const Support: React.FC = () => {
  const phoneNumber = "+380980965020";

  const links = {
    viber: `viber://chat?number=${phoneNumber}`,
    telegram: `https://t.me/${phoneNumber}`,
    phone: `tel:${phoneNumber}`,
  };

  const items = [
    {
      icon: <TelegramIcon />,
      title: "Telegram",
      description: "Перейти",
      onClick: () => {
        analytics().sendEvent(AnalyticsEvents.support_telegram);
        window.open(links.telegram, "_blank");
      },
    },
    {
      icon: <ViberIcon />,
      title: "Viber",
      description: "Перейти",
      onClick: () => {
        analytics().sendEvent(AnalyticsEvents.support_viber);
        window.open(links.viber, "_blank");
      },
    },
    {
      icon: <SupportIcon />,
      title: "Кол-центр",
      description: "098-096-50-20",
      onClick: () => {
        analytics().sendEvent(AnalyticsEvents.support_phone);
        window.open(links.phone);
      },
    },
  ];

  const renderItem = (item: {
    icon: React.ReactNode;
    title: string;
    description: string;
    onClick?: () => void;
  }) => (
    <Box key={item.title} sx={styles.supportItem}>
      {item.icon}
      <Box sx={{ ml: 2.5 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          {item.title}
        </Typography>
        <Link
          component="button"
          color="primary.main"
          underline="none"
          onClick={item.onClick}
        >
          {item.description}
        </Link>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ width: "100%" }}>
      <Typography sx={{ mb: 0.5 }} variant="h3">
        Служба підтримки
      </Typography>
      <Typography sx={{ mb: 3 }} variant="body1" color="grey700">
        Звертайтесь, як вам зручно
      </Typography>
      <Box sx={{ mt: 3, mb: 5, textAlign: "center", width: "100%" }}>
        <SupportImg />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          width: "100%",
          gap: 2,
        }}
      >
        {items.map(renderItem)}
      </Box>
    </Box>
  );
};

export default Support;
